import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "card-header",
  templateUrl: "./card-header.component.html",
  styleUrl: "./card-header.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CardHeaderComponent {}
